<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="msgBox" v-if="addType">
        <div class="contv">
          <form class="form">
            <div class="write-txt">
              <p class="write-title">内容库名称：<span>*</span></p>
              <div class="write-text">
                <!-- <textarea placeholder="" v-model="addObj.name"></textarea> -->
                 <input type="text" v-model="addObj.name">
              </div>
            </div>
            
            <div class="write-txt">
              <p class="write-title">内容类型：<span>*</span></p>
              <div class="write-text">
                <el-select v-model="addObj.type" placeholder="请选择">
                  <el-option
                    v-for="item in typelist"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </form>
          <div class="btnBox">
              <button class="btn btn-save" @click="saveSub">保存</button>
              <button class="btn btn-close" @click="closeSub">取消</button>
            </div>
        </div>
      </div>

      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加{{childrenID=='1-1'?'实词/虚词':childrenID=='1-2'?'古诗词':'现代文阅读'}}</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item name">
              <p>内容库名称：</p>
              <input type="text" placeholder="请输入要搜索的内容库名称" v-model="obj.name">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <p class="list-title">{{childrenID=='1-1'?'实词/虚词':childrenID=='1-2'?'古诗词':'现代文阅读'}}列表</p>
        <div class="organiza-list">
          <div class="titleList" :class="childrenID=='1-3'?'englist-title':''">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)" :class="childrenID=='1-3'?'englist-list':''">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.count">{{item.count}}</p>
              <p :title="item.add_time">{{item.create_time}}</p>
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="删除" style="color: #FF1919;" class="btn btn-remove" @click="removeShow(item)">删除</button>
                <button v-if="childrenID=='1-3'" style="color: #01CD81;" title="母题" class="btn btn-revise" @click="contentShow(item,'1')">母题</button>
                <button v-if="childrenID=='1-3'" style="color: #01CD81;" title="习题" class="btn btn-revise" @click="contentShow(item,'2')">习题</button>
                <button v-else :title="childrenID=='1-1'?'词库':'诗库'" class="btn btn-remove" @click="contentShow(item)" style="color: #01CD81;">{{childrenID=='1-1'?'词库':'诗库'}}</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="removeHide">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLibraryList,saveLibrary,getLibraryDetail,delLibrary,PackageSaveReview } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'1',
      childrenID:'',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'内容库名称'},
        {id:3,title:'数量'},
        {id:4,title:'添加时间'},
        {id:5,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        name:'',
        type:1,
      },
      totalPage:0,
      removeID:'',
      url:'',
      typelist:[
        {id:1,title:'实词/虚词'},
        {id:2,title:'古诗文'},
        {id:4,title:'现代文阅读'},
      ],
      reviewType:false,
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      reviewObj:{
        id:'',
        review:[]
      },
      reviewList:[
        {num:'',type:''}
      ]
    };
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.childrenID = this.$refs.navBox.childrenID = this.$route.query.id;
    this.$refs.navBox.navChange();
    this.getList();
  },
  components: {
    navBox,
    myHeader
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
      };
      this.addObj = {
        type:'1',
        model:'1',
        title:'',
        price:'',
        unit_price_value:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:''
      };
      this.vip_date = 'd'
      this.dataList = [];
      this.getList();
    },

    async getList(){
      var that = this;
      if(this.childrenID == '1-1'){
        this.obj.type = 1
      } else if(this.childrenID == '1-2'){
        this.obj.type = 2
      } else {
        this.obj.type = 4;
      }
      try {
        const response = await getLibraryList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getLibraryDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj =  response.data;
          that.addType = 'edit';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delLibrary({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.removeID = '';
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeHide(){
      var that = this;
      that.removeType = false;
      that.removeID = '';
    },

    async saveSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请输入资源名称！');
        return false;
      }
      try {
        const response = await saveLibrary(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.reviewType = false;
      this.addObj = {
        name:'',
        type:1,
      }
      this.reviewObj={
        id:'',
        review:[]
      };
      this.reviewList=[
        {num:'',type:''}
      ]
    },

    contentShow(e,type){
      if(this.childrenID == '1-1'){
        this.$router.push('/content?type='+e.type+'&lid='+e.id);
      } else if(this.childrenID == '1-2'){
        this.$router.push('/exam?type='+e.type+'&lid='+e.id);
      } else if(this.childrenID == '1-3'){
        if(type == 1){
          this.$router.push('/motif?type='+e.type+'&lid='+e.id);
        } else {
          this.$router.push('/exercises?type='+e.type+'&lid='+e.id);
        }
      }
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 5 );
  }

  .dataList .listItem p.btnList{
    font-size: 0;
  }

  .btnList .btn{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #333333;
    margin: 0 10px 10px 0;
    text-align: left;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 63px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .btn-import{
    display: inline-block;
    vertical-align: top;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .reviewBox .write-text input,
  .write-txt>>> .el-radio-group{
    display: inline-block;
    vertical-align: middle;
  }

  .reviewBox .write-text input{
    margin-right: 20px;
  }

  .reviewBox .btn-add{
    font-size: 18px;
    color: #00C7A3;
    border-radius: 6px;
    padding: 6px 24px;
    box-sizing: border-box;
    display: block;
    margin-top: 37px;
    border: solid 1px #00C7A3;
  }


  .MobelBox .write-text .btn.btn-review-remove{
    color: #fff;
    font-size: 18px;
    background-color: #F26060;
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
    margin-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 36px;
    display: inline-block;
    vertical-align: top;
    margin-left: 30px;
  }

  .el-select-dropdown .el-select-dropdown__item.selected{
    background-color: #01CD81;
    color: #fff;
  }

  .content>>> .el-radio__input.is-checked .el-radio__inner{
    background-color: #00C7A3;
    border-color: #00C7A3;
  }
  .content>>> .el-radio__input.is-checked+.el-radio__label{
    color: #00C7A3;
  }
  .content>>> .el-checkbox__input.is-focus .el-checkbox__inner{
    border-color: #00C7A3;
  }
</style>



// WEBPACK FOOTER //
// src/resource/index.vue